export interface GiphyMeta {
    status: number
    msg: string
    response_id?: string
}

export interface GiphyPagination {
    count: number
    offset: number
    total_count: number
}

export interface GiphyImage {
    url: string
    size: string
    webp: string
    webp_size: string
    mp4: string
    mp4_size: string
    width: string
    height: string
}

export interface GiphyImages {
    fixed_height: GiphyImage
}

export interface GiphyItem {
    id: string
    type: string
    url: string
    images: GiphyImages
}

export interface GiphyResponse {
    data: GiphyItem[]
    meta: GiphyMeta
    pagination: GiphyPagination
}

export function giphySearch(apiKey: string, query: string, abort: AbortSignal | null): Promise<GiphyResponse> {
    const params: RequestInit = {
        method: 'GET',
        signal: abort,
    }

    return fetch('https://api.giphy.com/v1/gifs/search?api_key=' + apiKey + '&q=' + encodeURIComponent(query), params)
        .then(res => res.json())
        .then(res => res as GiphyResponse)
}
